import { render, staticRenderFns } from "./BarChat.vue?vue&type=template&id=cab03b08"
import script from "./BarChat.vue?vue&type=script&lang=ts"
export * from "./BarChat.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports